import { render, staticRenderFns } from "./ProblemReporting.vue?vue&type=template&id=da5d1ca4&scoped=true"
import script from "./ProblemReporting.vue?vue&type=script&lang=js"
export * from "./ProblemReporting.vue?vue&type=script&lang=js"
import style0 from "./ProblemReporting.vue?vue&type=style&index=0&id=da5d1ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5d1ca4",
  null
  
)

export default component.exports